import i18n from '@/i18n'
import { availableReferralStatuses, availableReferralStatusReasons, ReferralType } from '@/api/types'
import { availableReferralChannels, ReferralChannel } from '@/api/types'
import { Contact } from '@/api/model/contact'
import { Company } from '@/api/model/company'
import { CompanyAPI } from '@/api/backend-client'

export interface InputSelectOption {
    label: string
    value: boolean|number|string
    subtext?: string
}

export const generateYesNoOptions = (): InputSelectOption[] => {
    return [
        {
            label: i18n.t('no').toString(),
            value: 0,
        },
        {
            label: i18n.t('yes').toString(),
            value: 1,
        },
    ]
}

export const generateReferralTypeOptions = (): InputSelectOption[] => {
    return [
        {
            label: i18n.t('referral.type.mortgage').toString(),
            value: ReferralType.MORTGAGE,
        },
        {
            label: i18n.t('referral.type.purchase').toString(),
            value: ReferralType.PURCHASE,
        },
        {
            label: i18n.t('referral.type.appraisal').toString(),
            value: ReferralType.APPRAISAL,
        },
    ]
}

export const generateReferralStatusOptions = (company: Company|null = null): InputSelectOption[] => {
    return availableReferralStatuses(company).map(status => {
        let labelTranslationKey
        if (company && company.pipelinesEnabled) {
            labelTranslationKey = `referral.phaseModelStatus.${status}`
        } else {
            labelTranslationKey = `referral.status.${status}`
        }

        return {
            label: i18n.t(labelTranslationKey).toString(),
            value: status,
        }
    })
}

export const generateReferralStatusReasonOptions = (): InputSelectOption[] => {
    return availableReferralStatusReasons().map(statusReason => {
        return {
            label: i18n.t(`referral.statusReason.${statusReason}`).toString(),
            value: statusReason,
        }
    })
}

export const generateChannelOptions = (): InputSelectOption[] => {
    return availableReferralChannels().map((referralChannel: ReferralChannel) => {
        return {
            label: i18n.t('referral.channel.' + referralChannel).toString(),
            value: referralChannel,
        }
    })
}

export const generateSourceOptions = (company: Company, channel: ReferralChannel = null): InputSelectOption[] => {
    return company.activeSources
        .filter(source => channel === null || source.channel === channel)
        .map(source => ({
            label: source.name,
            value: source.id,
        }))
}
